module.exports = __webpack_public_path__ + "static/media/pdf.9e9b7c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pdf.png
// module id = 237
// module chunks = 0